import { ReactNode } from 'react';

import { isFeatureEnabled } from '../../config';
import { AuditLogUIViewModel } from '../../services/backendServices/ViewModels';
import { Button, Dialog, FCNC } from '../../ui';
import { AuditLog, IAuditLogProps } from './AuditLog';

export interface AuditLogDialogProps {
    title: ReactNode;
    open: boolean;
    handleOnClose: () => void;
    logData: Map<string, AuditLogUIViewModel>;
    stopPropagation?: boolean;
    testId?: string;
    extractAdditionalDetails?: IAuditLogProps['extractAdditionalDetails'];
}

const useOldAuditLog = isFeatureEnabled('UseOldAuditLog');

export const AuditLogDialog: FCNC<AuditLogDialogProps> = ({
    title,
    open,
    handleOnClose,
    logData,
    stopPropagation,
    testId,
    extractAdditionalDetails,
}) => (
    <Dialog
        title={title}
        open={open}
        handleOnClose={handleOnClose}
        content={<AuditLog logData={logData} extractAdditionalDetails={extractAdditionalDetails} />}
        actions={<Button onClick={handleOnClose}>Close</Button>}
        testId={testId}
        staticWidth={useOldAuditLog}
        fullWidth={!useOldAuditLog}
        maxWidth={useOldAuditLog ? undefined : '90vw'}
        maxHeight={useOldAuditLog ? undefined : '90vh'}
        stopPropagation={stopPropagation}
    />
);
